import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";

import {
    REQUEST_LIST_PASSPORTS,
    REQUEST_ADD_PASSPORT,
    REQUEST_UPDATE_PASSPORT_WITH_OAUTH,
    REQUEST_UPDATE_PASSPORT,
    REQUEST_REMOVE_PASSPORT,
    REQUEST_BASE_URL,
    REQUEST_CODE_CHALLENGE,
    REQUEST_ACCESS_TOKEN,
} from "userful-chronos-app-common-js/dist/message/messageTypeDefinitions/integration/powerpointMsgDefinitions";
import {
    PowerPointPassportHeader,
    PowerPointPassportID,
    PowerPointEmbedUrlRequest,
} from "userful-chronos-app-common-js/dist/models/integration/powerpoint";
import "./powerpointMsgReciever";

export const requestListPassports = () => {
    getGlobalStates().eventBus.sendMsg(REQUEST_LIST_PASSPORTS);
};

export const requestAddPassport = (payload: PowerPointPassportHeader) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_ADD_PASSPORT, payload);
};

export const requestUpdatePassportWithOAuth = (payload: PowerPointPassportHeader) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_UPDATE_PASSPORT_WITH_OAUTH, payload);
};

export const requestUpdatePassport = (payload: PowerPointPassportHeader) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_UPDATE_PASSPORT, payload);
};

export const requestRemovePassport = (payload: PowerPointPassportID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_REMOVE_PASSPORT, payload);
};

export const requestBaseURL = (payload: PowerPointPassportID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_BASE_URL, payload);
};

export const requestPreviewURL = (payload: PowerPointEmbedUrlRequest) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_BASE_URL, payload);
};

export const requestCodeChallenge = (payload: PowerPointPassportID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_CODE_CHALLENGE, payload);
};

export const requestAccessToken = (payload: PowerPointPassportID) => {
    getGlobalStates().eventBus.sendMsg(REQUEST_ACCESS_TOKEN, payload);
};
